import api from "../config/axios";
import dayjs from "dayjs";
import intervalHelper from "../helpers/intervalHelper";
import config from "~/config";
export default {
  GET: async () => {
    const { data } = await api.get("mitt-konto/get-account");
    return data;
  },
  POST: {
    LOGIN: async (payload, vm) => {
      try {
        const token = await window.grecaptcha.execute(
          config.RECAPTCHA_SITE_KEY,
          {
            action: "loginform",
          }
        );
        payload.recaptchaToken = token;
        const url = "tokens";
        const { data } = await api.post(url, payload, {
          recaptchaAction: url,
        });
        const date = new Date();
        date.setTime(date.getTime() + 1 * 60 * 60 * 1000);

        document.cookie = `StarJwtTokenCookieName=Token=${data}&Created=${dayjs().format(
          "YYYY-MM-DD HH:mm:ss"
        )}; expires=${date.toUTCString()}; path=/`;

        intervalHelper.createInterval(vm);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    REQUEST_RESET_PASSWORD: async (payload) => {
      const url = `mitt-konto/request-reset-password`;
      try {
        /*
       Check whether recaptcha is implemented on the endpoint, if not it should be..
       const token = await window.grecaptcha.execute(
          config.RECAPTCHA_SITE_KEY,
          {
            action: "request-reset-password-form",
          }
        );
        payload.recaptchaToken = token; */
        const { data } = await api.post(
          url,
          payload /*, {
          recaptchaAction: url,
        }*/
        );
        return data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
